'use client';
/** @jsxImportSource @emotion/react */

import type { FormControlLabelProps as MuiFormControlLabelProps } from '@mui/material/FormControlLabel';

import MuiFormControlLabel from '@mui/material/FormControlLabel';

type ExcludedMuiProps = '';

interface FormControlLabelProps
  extends Omit<MuiFormControlLabelProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { FormControlLabelProps };
export const FormControlLabel: React.FC<FormControlLabelProps> =
  MuiFormControlLabel;

FormControlLabel.displayName = 'FormControlLabel';
